/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MnGnbData model module.
 * @module model/MnGnbData
 * @version 1.0
 */
class MnGnbData {
    /**
     * Constructs a new <code>MnGnbData</code>.
     * @alias module:model/MnGnbData
     */
    constructor() { 
        
        MnGnbData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MnGnbData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MnGnbData} obj Optional instance to populate.
     * @return {module:model/MnGnbData} The populated <code>MnGnbData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MnGnbData();

            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('gnbName')) {
                obj['gnbName'] = ApiClient.convertToType(data['gnbName'], 'String');
            }
            if (data.hasOwnProperty('pageUrl')) {
                obj['pageUrl'] = ApiClient.convertToType(data['pageUrl'], 'String');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MnGnbData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MnGnbData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['gnbName'] && !(typeof data['gnbName'] === 'string' || data['gnbName'] instanceof String)) {
            throw new Error("Expected the field `gnbName` to be a primitive type in the JSON string but got " + data['gnbName']);
        }
        // ensure the json data is a string
        if (data['pageUrl'] && !(typeof data['pageUrl'] === 'string' || data['pageUrl'] instanceof String)) {
            throw new Error("Expected the field `pageUrl` to be a primitive type in the JSON string but got " + data['pageUrl']);
        }

        return true;
    }


}



/**
 * @member {Number} gnbNo
 */
MnGnbData.prototype['gnbNo'] = undefined;

/**
 * @member {String} gnbName
 */
MnGnbData.prototype['gnbName'] = undefined;

/**
 * @member {String} pageUrl
 */
MnGnbData.prototype['pageUrl'] = undefined;

/**
 * @member {Number} sort
 */
MnGnbData.prototype['sort'] = undefined;

/**
 * @member {Boolean} enabled
 */
MnGnbData.prototype['enabled'] = undefined;






export default MnGnbData;

